import { Component, OnInit, ChangeDetectorRef, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { MemberService } from '../../services/jrni/member.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { Router } from '@angular/router';
import { AlertService } from '../../_alert';
import { ServicesService } from '../../services/jrni/services.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatastoreService } from '../../services/datastore.service';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { AppConfig } from '../../app.config';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { AmazonService } from '../../services/jrni/amazon.service';
import moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
})
export class ServicesComponent implements OnInit {
  selectedDepartment;
  pageTitle;
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;
  servicePageText;
  servicesList: any = [];
  initialSelectedService;
  selectedService;
  private customerQuestions = AppConfig.settings.customerQuestions;
  private services = AppConfig.settings.services;
  location;
  permitQuestion = false;
  guidanceMsgPermits: any;
  tickBlock = false;
  checkboxInterval: any = undefined;
  display_location_and_services_page_permit_guidance: boolean;
  selectedServiceIndex = null

  constructor(
    private departmentService: DepartmentService,
    private router: Router,
    protected alertService: AlertService,
    private servicesService: ServicesService,
    private cdref: ChangeDetectorRef,
    private translateService: TranslateService,
    private spinner: NgxSpinnerService,
    private datastoreService: DatastoreService,
    private amazonService: AmazonService,
    private availabilityService: AvailabilityService,
    private sanitized: DomSanitizer,
  ) { }

  // Go back to the booking details page
  routerGoBack() {
    // If location is before services then redirect back to locations else redirect back to departments

    this.router.navigate(['/departments']);
  }

  restartJourney() {
    this.router.navigate(['/departments']);
  }

  ngOnInit() {
    this.datastoreService.bookingForm = null;
    this.datastoreService.selectedDate = null;
    this.datastoreService.selectedSlot = null;
    this.datastoreService.permitData = null;
    this.availabilityService.setSelectedSlot(null);
    this.scrollToTop();
    this.spinner.show();

    // Use this.departmentService.getLocation() if the services are set on the children departments
    // Use this.departmentService.get() if the services are set on the parent department
    this.departmentService.get().then(
      async (selectedDepartment) => {
        if (selectedDepartment === undefined) {
          this.restartJourney();
        } else {
          this.selectedDepartment = selectedDepartment;
          console.log(this.selectedDepartment);
          // Get the configurable data
          let parentDepartment =
            await this.departmentService.getParentDepartment();
          console.log(parentDepartment);
          if (selectedDepartment?.extra?.services_page_title) {
            this.pageTitle = selectedDepartment.extra.services_page_title;
          } else if (parentDepartment.hasOwnProperty('extra')) {
            // Set the title on the login page to the title from the business question
            parentDepartment.extra.hasOwnProperty('services_page_title')
              ? (this.pageTitle =
                parentDepartment.extra.services_page_title)
              : (this.pageTitle = 'Services title not set');
            // Set the extra text on the page to the text taken from the business question
            this.selectedDepartment.extra.hasOwnProperty('services_page_text')
              ? (this.servicePageText =
                this.selectedDepartment.extra.services_page_text)
              : null;
          }
          if (parentDepartment?.extra?.location_and_services_page_permit_guidance_text) {
            this.guidanceMsgPermits = parentDepartment?.extra?.location_and_services_page_permit_guidance_text
          }
          if (parentDepartment?.extra?.display_location_and_services_page_permit_guidance) {
            this.display_location_and_services_page_permit_guidance = parentDepartment.extra.display_location_and_services_page_permit_guidance === "Yes";

          }
          this.getServices();
        }
      },
      (err) => {
        this.alertService.error(
          this.translateService.instant('COMMON.GENERAL_ERR')
        );
        this.spinner.hide();
      }
    );
  }

  // Get the available services on the selected department
  async getServices() {
    let services = await this.servicesService.getServices(
      this.selectedDepartment
    );

    // if (services.length === 1) {
    //   this.selectService(services[0])
    // } else {
    console.log(services);
    let unsortedServices = []
    for (let element of services) {
      //let childServices = await element.$getChildServices();

      // let service: any = {};

      // service.name = element.name
      // service.description = element.description

      // childServices.forEach(element => {
      //   element.$getImages().then((image) => {
      //     service.image = image[0];
      //   });
      // });
      if (
        element.extra === undefined ||
        element.extra.permits_enabled === undefined
      ) {
        element.extra = { permits_enabled: 'No' };
      }
      console.log(element);
      element.permitQuestion = undefined;
      element.vehicleRegQuestion = undefined;
      if (element.extra.admin_only_service !== 'Yes') {
        unsortedServices.push(element);
      }
    }

    //
    // 
    // 
    //
    // 
    this.find("Car, campervan or motorcycle", unsortedServices)
    this.find("Car with trailer", unsortedServices)
    this.find("Van or pickup", unsortedServices)
    this.find("Bicycle or pedestrian", unsortedServices)
    this.find("Hire vehicle", unsortedServices)

    for (let f of unsortedServices) {
      if (!this.servicesList.find((x) => x.name === f.name)) {
        this.servicesList.push(f)
      }
    }

    this.spinner.hide();
    // }
  }

  find(find, unsortedServices) {
    const found = unsortedServices.find((x) => x.name === find)
    if (found) {
      this.servicesList.push(found)
    }
  }

  selectService(service) {
    this.selectedService = service;

    this.continue('/calendar');
  }

  async askQuestion(service) {
    const res = await service.$get('questions');
    let question = res.questions.find((x) => {
      return x.id.toString() === AppConfig.settings.permitQuestion.toString();
    });
    console.log(res);
    console.log(question);
    service.permitQuestion = question;
    console.log(service.permitQuestion);

    question = res.questions.find((x) => {
      return (
        x.id.toString() === AppConfig.settings.vehicleRegQuestion.toString()
      );
    });
    service.vehicleRegQuestion = question;
    service.contact_details = {};
    service.permitQuestion.error = false;
    service.permitQuestion.apiError = false;
    service.permitQuestion.apiNote = false;
    service.permitQuestion.apiSuccess = false;
    service.permitQuestion.answer = '';

    service.permitQuestion.error = false;
    service.permitQuestion.apiError = false;
    service.permitQuestion.apiNote = false;
    service.permitQuestion.apiSuccess = false;
    service.showContinue = false;
    service.vehicleRegQuestion.answer = '';

    service.status = 0;
  }

  async checkPermit(service) {
    this.spinner.show();

    // this will do a check to see if the permit exists and will then load it
    service.permitQuestion.error = false;
    service.permitQuestion.apiError = false;
    service.permitQuestion.apiNote = false;
    service.permitQuestion.apiSuccess = false;
    service.showContinue = false;
    service.status = 0;
    if (service.permitQuestion.answer) {
      const companyName = AppConfig.settings.apiServer.api_url
        .split('//')[1]
        .split('.council')[0];
      const permit: any =
        await this.amazonService.checkPermitApplicationOperation(
          this.selectedDepartment.id,
          companyName,
          service.permitQuestion.answer,
          'validatePermit'
        );
      service.permit = permit;
      if (permit.found === true) {
        // this.continue("/calendar");
        if (permit.error === 'invalid') {
          service.permitQuestion.apiError =
            'Permit number invalid. Please try again.';
        } else if (permit.error === 'no allowance') {
          service.permitQuestion.apiError =
            'Your permit allowance has been used. Please apply for a new permit.';
        } else if (permit.error === 'expired') {
          service.permitQuestion.apiError =
            'Your permit has expired. Please apply for a new permit.';
        } else if (permit.reg) {
          if (permit.hire) {
            service.permitQuestion.apiNote = `Your permit is for a hired vehicle, you must provide the following when you visit:
            <div>
              <ul>
                <li>the short-term hire agreement</li>
                <li>photographic identification</li>
                <li>proof of address</li>
              </ul>
            </div>
            Please enter the vehicle registration for your permit.
            `;
          } else {
            service.permitQuestion.apiNote =
              'Please enter the vehicle registration for your permit.';
          }
          service.status = 1;
        } else {
          service.permitQuestion.apiNote = `Your permit is for a hired vehicle, you must provide the following when you visit:
          <div>
            <ul>
              <li>the short-term hire agreement</li>
              <li>photographic identification</li>
              <li>proof of address</li>
            </ul>
          </div>
          `;
          service.permitQuestion.apiSuccess = `Your permit is valid and you have ${permit.remaining} visits remaining. Please continue.`;
          console.log(service.permitQuestion.apiSuccess);
          service.showContinue = true;
        }
        if (permit.vehicle_model) {
          service.vehicleRegQuestion.vehicle_model = permit.vehicle_model;
        }
        if (permit.hire) {
          service.permitQuestion.hire = 'Yes';
        } else {
          service.permitQuestion.hire = 'No';
        }
      } else {
        // this.alertService.warn("Permit invalid");
        service.permitQuestion.apiError =
          'Permit number not found. Please try again.';
      }
    } else {
      // this.alertService.warn("Please enter your permit number");
      service.permitQuestion.error = true;
    }
    this.spinner.hide();
  }
  cancelPermit(service) {
    service.permitQuestion.error = false;
    service.permitQuestion.apiError = false;
    service.permitQuestion.apiNote = false;
    service.permitQuestion.apiSuccess = false;
    service.showContinue = false;
    service.permitQuestion.answer = '';
    service.status = 0;
  }

  async checkVehicleReg(service) {
    this.spinner.show();
    // this will do a check to see if the permit exists and will then load it
    service.vehicleRegQuestion.empty = false;
    service.contact_details.empty = false;
    service.vehicleRegQuestion.error = false;
    service.vehicleRegQuestion.apiError = false;
    service.vehicleRegQuestion.apiNote = false;
    service.vehicleRegQuestion.apiSuccess = false;
    service.showContinue = false;
    service.renewButton = false
    console.log("service.vehicleRegQuestion.answer", service.vehicleRegQuestion.answer)
    if (!service.vehicleRegQuestion.answer) {
      // this.alertService.warn("Please enter your permit number");
      service.vehicleRegQuestion.empty = true;
    }
    if (!service.contact_details.email_address) {
      // this.alertService.warn("Please enter your permit number");
      service.contact_details.empty = true;
    }
    if (!(service.contact_details.empty || service.vehicleRegQuestion.empty)) {
      const companyName = AppConfig.settings.apiServer.api_url
        .split('//')[1]
        .split('.council')[0];
      const reg: any = await this.amazonService.checkPermitApplicationOperation(
        this.selectedDepartment.id,
        companyName,
        service.permitQuestion.answer,
        'validateVehicleOnly',
        service.vehicleRegQuestion.answer,
        service.contact_details.email_address,
        service.contact_details.email_address
      );
      console.log()
      if (reg.found) {
        if (reg.record.status !== "2") {
          service.vehicleRegQuestion.apiError = `Your permit is not valid`;
        }
        else if (reg.record.annual_allowance === "0") {
          service.vehicleRegQuestion.apiError = `Your permit allowance has been used. You will be able to reapply for a new permit for this vehicle after ${moment(reg.record.valid_to).format("DD-MM-YYYY")} when your permit expires.`;
        }
        else if (moment(reg.record.valid_to).isBefore(moment())) {
          service.vehicleRegQuestion.apiError = `Your permit has expired. Please renew your permit.`;
          service.renewButton = true
        }
        else {
          this.selectedService = service;
          console.log(this.selectedService);
          // this.continue("/calendar");
          service.vehicleRegQuestion.apiSuccess = `Your permit is valid and you have ${reg.record.annual_allowance} visits remaining. Please continue.`;
          service.vehicleRegQuestion.apiSuccess =
            `Your permit is valid and you have ${reg.record.annual_allowance} visits remaining. 
Your permit expires on ${moment(reg.record.valid_to).format("DD-MM-YYYY")}.
Please continue.`;

          service.showContinue = true;
          const permitData = JSON.parse(reg.record.data)
          permitData.permit_id = reg.record.permit_id
          this.datastoreService.permitData = permitData
          console.log(" this.datastoreService.permitData", this.datastoreService.permitData)
        }
      } else {
        service.vehicleRegQuestion.error = true
      }
    }
    this.spinner.hide();
  }

  cancelReg(service) {
    service.vehicleRegQuestion.error = false;
    service.vehicleRegQuestion.apiError = false;
    service.vehicleRegQuestion.apiNote = false;
    service.vehicleRegQuestion.apiSuccess = false;
    service.showContinue = false;
  }

  applyForPermit(service) {
    this.selectedService = service;

    this.continue('/permits');
  }

  renewPermit(service) {
    this.selectedService = service;

    this.continue('/amend-permits');
  }

  continue(goTO, skipService = false) {
    if (this.selectedService || skipService) {
      console.log(this.selectedService);
      if (!skipService) {
        this.servicesService.set(this.selectedService);
      }
      this.router.navigate([goTO]);
    } else {
      this.alertService.warn('Please select a service before proceeding');

      this.scrollToTop();
    }
  }

  // scroll to the top of the page
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }

  selectInitialSelectedService(service, index) {
    this.tickBlock = true
    console.log("SD", service.description, service?.description instanceof String)
    if (service.extra.enable_checkbox_for_car_with_trailer === 'Yes') {
      this.tickBlock = false
    }
    this.initialSelectedService = service;
    this.selectedServiceIndex = index;
    console.log("SD", this.initialSelectedService.description)
    if (service?.extra.permits_enabled === 'Yes') {
      this.askQuestion(service)
    }
    console.log()
    console.log()
    if (document.getElementById("0").offsetWidth + 100 > document.getElementById("buttonGroup").offsetWidth) {
      document.getElementById("scroll-center").scrollIntoView();
    }
  }

  onQuestionChange(service) {
    console.log("change")
    service.vehicleRegQuestion.apiSuccess = false;
    service.showContinue = false;

  }

  ngOnDestroy() {
    if (this.checkboxInterval) {
      clearInterval(this.checkboxInterval)
    }
  }

  applyExternal() {
    window.location.href = 'https://www.dorsetcouncil.gov.uk/w/vehicle-permits-for-household-recycling-centres';  
  }

}
